import { Box, Typography, Menu, MenuItem, Button, IconButton, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { useState, useCallback } from "react";

import { RouteUrls } from "Constants/RouteUrls";
import { handleNavigation } from "Components/Header";
import ColorData from "Components/CstmTheme/ColorData";
import MenuIcon from "@mui/icons-material/Menu";
import MobileDrawer from "Components/commonComponents/HederDrawer";
interface SubTopBarProps {
  // drawerOpen: boolean;
  // setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export const menuItems = [
  {
    id: "legalServices",
    label: "Legal Services",
    hasDropdown: true,
    submenu: [
      "Legal Notice- Send and Reply",
      "Legal Drafting",
      "Legal Document Review",
      "File or Defend a Case",
      "Talk to a Lawyer"
    ],
  },
  {
    id: "legalFinance",
    label: "Legal Finance",
    hasDropdown: true,
    submenu: ["Third Party Litigation Funding", "New Feature-Coming Soon"],
  },
  {
    id: "odr",
    label: "Online Dispute Resolution",
    hasDropdown: true,
    submenu: ["Online Mediation", "Online Arbitration"],
  },
  {
    id: "talkExpert",
    label: "Talk with an Expert",
    hasDropdown: true,
    submenu: [
      "Talk to a Lawyer",
      "Talk to a Chartered Accountant",
      "Talk to a Company Secretary"
    ],
  },
  {
    id: "startupSupport",
    label: "Start-up Support Service",
    hasDropdown: true,
    submenu: [
      "Incorporate your Business",
      "Start-up Tool Kit",
      "Fund Raising",
      "DPDP Compliance",
      "Pitch Deck",
      "Due-Diligence",
      "Virtual Legal Counsel",
      "Website Development Services",
      "Posh Compliance"
    ],
  },
  {
    id: "businessReg",
    label: "Business Registration",
    hasDropdown: true,
    submenu: [
      "Register Private Limited Company",
      "Register Limited Liability Partnership (LLP)",
      "Register Subsidiary Company",
      "Register Producer Company",
      "Register One Person Company",
      "Register Nidhi Company",
      "Register Sole Proprietorship",
      "Register Partnership"
    ],
  },
  {
    id: "forInvestors",
    label: "For Investors",
    hasDropdown: true,
    submenu: [
      "Alternative Fund Incubation",
      "Investment Execution Advisory",
      "Investment Transaction Life Cycle",
      "Exit Support and Compliance"
    ],
  },
  {
    id: "taxCompliance",
    label: "Tax & Compliance",
    hasDropdown: true,
    submenu: [
      "Income Tax Return Filling",
      "TDS Return Filling",
      "GST Registration Online",
      "GST Filling Online",
      "Annual Accounting services",
      "Licenses and Registration",
      "Changes in Private Limited Company",
      "Changes in LLP",
      "Business Entity Conversion",
      "Secretarial Audit",
      "Register Copyright",
      "Register Patent",
      "Register Trademark",
      "Register your Design",
      "IP-Infringement"
    ],
  },
  {
    id: "otherServices",
    label: "Other Services",
    hasDropdown: true,
    submenu: [
      "NGO Registration and Compliance",
      "File RTI Application",
      "Virtual Legal Counsel",
      "Legal Protection Plan",
      "NRI and Overseas Indians Help Desk",
      "Consumer complaint"
    ],
  },
];

const SubTopBar: React.FC<SubTopBarProps> = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery('(max-width:900px)');

  // Debug log to check mobile detection
  // console.log("isMobile:", isMobile, "isSmallScreen:", isSmallScreen, "window width:", typeof window !== 'undefined' ? window.innerWidth : 'SSR');

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, menuId: string) => {
    if (isMobile || isSmallScreen) {
      setDrawerOpen(true);
    } else {
      setAnchorEl(event.currentTarget);
      setOpenMenuId(menuId);
    }
  };



  const handleDrawerToggle = useCallback(() => {
    setDrawerOpen(prev => !prev);
  }, []);



  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenuId(null);
  };



  return (
    <Box
      sx={{
        px: 3,
        py: 2,
        bgcolor: "white",
        width: "100%",
        minHeight: '60px', // Ensure minimum height
      }}
    >
      {/* Mobile Menu - Always show on small screens */}
      {/* <Box
        sx={{
          display: { xs: 'flex', md: 'none' }, // Show on xs and sm, hide on md and up
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '100%',
          minHeight: '48px',
        }}
      >
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
            color: ColorData.text.primary,
            p: 1.5,
            mr: 1,
            backgroundColor: 'rgba(162, 72, 87, 0.05)',
            border: '1px solid rgba(162, 72, 87, 0.2)',
            borderRadius: 1,
            '&:hover': {
              backgroundColor: 'rgba(162, 72, 87, 0.1)',
              borderColor: 'rgba(162, 72, 87, 0.4)',
            },
            '&:active': {
              backgroundColor: 'rgba(162, 72, 87, 0.15)',
            }
          }}
          aria-label="Toggle navigation menu"
        >
          <MenuIcon sx={{ fontSize: '1.5rem', color: ColorData.primary.main }} />
        </IconButton>
        <Typography
          variant="h6"
          sx={{
            color: ColorData.text.primary,
            fontWeight: 600,
            fontSize: '1.1rem'
          }}
        >
          Services Menu
        </Typography>
      </Box> */}

      {/* Fallback for debugging - remove this after testing */}
      {/* {(isMobile || isSmallScreen) && (
        <Box
          sx={{
            position: 'fixed',
            top: 10,
            right: 10,
            zIndex: 9999,
            backgroundColor: 'red',
            color: 'white',
            p: 1,
            fontSize: '12px',
            borderRadius: 1,
          }}
        >
          Mobile: {isMobile ? 'Yes' : 'No'} | Small: {isSmallScreen ? 'Yes' : 'No'}
        </Box>
      )} */}

      {/* Desktop Menu */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' }, // Hide on xs and sm, show on md and up
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {menuItems.map((item) => (
          <Box key={item.id} sx={{ position: "relative" }}>
            <Button
              onClick={(e) => handleMenuClick(e, item.id)}
              endIcon={<ArrowDropDownIcon sx={{ fontSize: "1rem" }} />}
              sx={{
                fontSize: 14,
                fontWeight: "bold",
                color: "#333",
                textTransform: "none",
                padding: 0,
                minWidth: "auto",
                "&:hover": { color: "#2a3162" },
                "& .MuiButton-endIcon": { ml: 0.5 },
              }}
            >
              {item.label}
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={openMenuId === item.id}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              slotProps={{
                paper: {
                  sx: {
                    mt: 0.5,
                    boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                    borderRadius: 2,
                    bgcolor: "#2a3162",
                    color: "#fff",
                    minWidth: "180px",
                  },
                },
              }}
            >
              {item.submenu?.map((subItem) => (
                <MenuItem
                  key={subItem}
                  onClick={() => {
                    handleMenuClose();
                    handleNavigation(subItem);
                  }}
                  sx={{
                    fontSize: "0.875rem",
                    padding: "8px 16px",
                    "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                  }}
                >
                  <Typography color="background.default" sx={{ fontSize: "14px" }}>
                    {subItem}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        ))}
      </Box>



      {/* Mobile Drawer */}
      {/* <MobileDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        navItems={menuItems}
        expandedItems={expandedItems}
        onExpandClick={handleExpandClick}
        onNavigate={(item: string) => {
          handleNavigation(item);
          handleDrawerClose(); // Close drawer after navigation
        }}
      /> */}
    </Box>
  );
};

export default SubTopBar;